import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';
export const Wrapper = props => {
  const $ = _c(15);
  const t0 = props.isFocused ? "colorPalette.border" : "colorPalette.border/50";
  const t1 = props.isFocused ? "sm" : "none";
  const t2 = props.isFocused ? "colorPalette.border" : "colorPalette.border/50";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      borderColor: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== props.typographyStyles) {
    t4 = props.typographyStyles || {};
    $[2] = props.typographyStyles;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = {
      ...t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props.boxProps) {
    t6 = props.boxProps || {};
    $[6] = props.boxProps;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== props.children || $[9] !== t0 || $[10] !== t1 || $[11] !== t3 || $[12] !== t5 || $[13] !== t6) {
    t7 = <Box bgColor="colorPalette.bg/50" borderColor={t0} borderRadius="md" borderWidth="1px" boxShadow={t1} width="full" _hover={t3} css={t5} {...t6}>{props.children}</Box>;
    $[8] = props.children;
    $[9] = t0;
    $[10] = t1;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};